import { CreditBar } from "modules/credit-profile/components";
import React from "react";

function PanelAction() {
  return <CreditBar />;
}

export default React.memo(PanelAction);
